import ZT1DPositioningModal from './ZT_1D_positioning-modal.vue'
export default ZT1DPositioningModal
